(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	var GSA_AND_DELIMITER = '.';
	var GSA_EQUAL_DELIMITER = ':';
	var GSA_FACET_PREFIX = 'gsaentity_GSA_';

	function addFilterParams(defaultFilter) {
		// A pre-filter that transforms the filter config property into a “requiredfields” facet filtering string readable by the GSA.
		// Must be added before paramsTransposer from url-handling.js
		defaultFilter = defaultFilter || {};
		return function filterParamsAdder(config, callback) {
			if(!('filter' in config)) {
				// Create a copy of the default filter
				config.filter = search.util.extend({}, defaultFilter);
			}
			var filterString = '';
			for(var name in config.filter) {
				// jshint forin: false
				filterString += GSA_FACET_PREFIX+name + GSA_EQUAL_DELIMITER + config.filter[name] + GSA_AND_DELIMITER;
			}
			if(filterString) {
				// Cut off the last GSA_AND_DELIMITER
				config.requiredfields = filterString.slice(0, -1);
				config.gsaFilter = 'duplicateSnippet';
			}
			callback();
		};
	}

	function split(sites) {
		if(typeof sites === 'string') {
			return sites.split(/\|+/);
		}
		return sites || [];
	}

	function addSiteParams(defaultSites) {
		defaultSites = split(defaultSites);
		// Makes it easy to pass sites as an array and converts it into a pipe-separated string as necessary
		return function siteParamsAdder(config, callback) {
			if('site' in config) {
				config.sites = split(config.site);
				return callback();
			}
			if('sites' in config) {
				config.sites = split(config.sites);
			} else {
				config.sites = defaultSites;
			}
			if(config.sites && config.sites.length) {
				config.site = config.sites.join('|');
			}
			
			callback();
		};
	}

	function handlePaging() {
		// Adjusts the offset to the current page number (if given)
		return function pagingHandler(config, callback) {
			if(!config.inputConfig || 'offset' in config.inputConfig || !('offset' in config) || !('page' in config)) {
				// Explicit offset given, ignore
				// Or no page given, ignore
				return callback();
			}
			config.offset = config.page * config.resultLimit;
			callback();
		};
	}

	function aggregateMetaTags() {
		// Converts the metaTags attribute of each result to an object format
		return function metaTagsAggregator(data, config, callback) {
			var results = data.results || [];

			for(var i=0;i<results.length;i+=1) {
				var result = results[i];
				var metaTags = result.metaTags || [];
				var meta = result.meta = {};
				for(var j=0;j<metaTags.length;j+=1) {
					var metaTag = metaTags[j];
					meta[metaTag.name] = metaTag.value;
				}
			}

			callback();
		};
	}

	function aggregateDynNavFacets() {
		// Converts the dynNav facets attribute of the data to an object format
		return function dynNavFacetsAggregator(data, config, callback) {
			var facets = (data.dynNav && data.dynNav.facets) || [];
			config.facets = {};
			for(var i=0;i<facets.length;i+=1) {
				var facet = facets[i];
				var name = facet.name;
				if(name.indexOf(GSA_FACET_PREFIX) === 0) {
					name = name.substring(GSA_FACET_PREFIX.length);
				}
				facet = config.facets[name] = search.util.extend({}, facet);
				var values = facet.values || [];
				facet.values = {};
				for(var j=0;j<values.length;j+=1) {
					var value = values[j];
					facet.values[value.value] = value;
				}
			}
			callback();
		};
	}

	function setUp(processor, filterParamsAdder, siteParamsAdder, pagingHandler, metaTagsAggregator, dynNavFacetsAggregator) {
		processor.usePre(filterParamsAdder||addFilterParams());
		processor.usePre(siteParamsAdder||addSiteParams());
		processor.usePre(pagingHandler||handlePaging(), 50000);
		processor.usePost(metaTagsAggregator||aggregateMetaTags(), 500);
		processor.usePost(dynNavFacetsAggregator||aggregateDynNavFacets(), 510);
	}

	var plugins = search.plugins = search.plugins || {};
	var gsa = plugins.gsa = plugins.gsa || {};

	gsa.addFilterParams = addFilterParams;
	gsa.addSiteParams = addSiteParams;
	gsa.handlePaging = handlePaging;
	gsa.aggregateMetaTags = aggregateMetaTags;
	gsa.aggregateDynNavFacets = aggregateDynNavFacets;
	gsa.setUp = setUp;

})(window.SCS = window.SCS || {});


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/gsa-handling.js
// module id = 44
// module chunks = 0